export const baseUrl = 'http://localhost:3000/';
//export const baseUrl = 'http://192.168.1.5:3000';
/*Is the local host used to simulate a server locally using json-server.*/
//export const baseUrl = 'http://localhost:8080/';
//export const baseUrl = 'https://us-central1-edjserver.cloudfunctions.net/edjServer/';
